import { gql } from "@apollo/client";
import {
  ProductNoNestingFragment,
  CustomerDeepNestingFragment,
  CustomerAddressDeepNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";

export const QuerySearch = gql`
  query QuerySearch($input: SearchInput!) {
    search(input: $input) {
      items {
        id
        type
      }
    }
  }
`;

export const CompleteQuerySearch = gql`
  ${CustomerAddressDeepNestingFragment}
  ${CustomerDeepNestingFragment}
  ${ProductNoNestingFragment}
  query QuerySearch($input: SearchInput!) {
    search(input: $input) {
      items {
        id
        type
        entity {
          ... on Product {
            ...ProductNoNesting
            image {
              path
            }
          }
          ... on Customer {
            ...CustomerDeepNesting
          }
        }
      }
    }
  }
`;
